module.exports = __webpack_public_path__ + "img/Fuller_main.c392489a.jpg";